/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import Component from 'inferno-component';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/shared/reward/reward_styles';
import { createStyles } from 'utils/styles';
const sheet = createStyles(styles, {link:false});



/* ========== ~~~~~~~~~~ REWARD : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const Reward = (props) => {
	return (
        <div className={`${sheet.classes.reward} reward rewardAvailable-${props.newRewardAvailable}`}>
        	<span className={`rewardnum`}><span className={`number`}>{props.numOfRewards}</span></span>
        	{props.children}
        </div>
	);
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Reward;
